import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import {
  fetchPaymentMethodAuthorizationTokenRequest,
  updatePaymentMethodRequest,
  isLoadingPaymentMethodAuthorizationToken,
  isUpdatingPaymentMethod,
  hasUpdatedPaymentMethod,
  getPaymentMethodAuthorizationToken
} from 'store/paymentMethods';

import { Spinner } from 'components/Common';
import { PaymentCardForm } from 'components';

export class PaymentCardFormContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    hasUpdated: PropTypes.bool.isRequired,
    authorizationToken: PropTypes.string,
    onFetchPaymentMethodAuthorizationToken: PropTypes.func.isRequired,
    onUpdatePaymentMethod: PropTypes.func.isRequired
  };

  static defaultProps = {
    authorizationToken: null
  };

  componentDidMount() {
    this.props.onFetchPaymentMethodAuthorizationToken();
  }

  handleSubmit = nonce => {
    this.props.onUpdatePaymentMethod(this.props.authorizationToken, nonce);
  };

  render() {
    if (this.props.hasUpdated) {
      return (
        <div className="column small-12 large-8">
          <h2>{this.props.t('paymentMethod.thankYou.heading')}</h2>

          <p>{this.props.t('paymentMethod.thankYou.description')}</p>

          <Link className="button" to="/payment-method">
            {this.props.t('paymentMethod.thankYou.back')}
          </Link>
        </div>
      );
    }

    if (this.props.isLoading) {
      return <Spinner />;
    }

    return (
      <PaymentCardForm
        authorizationToken={this.props.authorizationToken}
        isUpdating={this.props.isUpdating}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoading: isLoadingPaymentMethodAuthorizationToken(state),
  isUpdating: isUpdatingPaymentMethod(state),
  hasUpdated: hasUpdatedPaymentMethod(state),
  authorizationToken: getPaymentMethodAuthorizationToken(state)
});

const mapDispatchToProps = {
  onFetchPaymentMethodAuthorizationToken: fetchPaymentMethodAuthorizationTokenRequest,
  onUpdatePaymentMethod: updatePaymentMethodRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(PaymentCardFormContainer)
);



// WEBPACK FOOTER //
// ./src/containers/PaymentCardFormContainer/PaymentCardFormContainer.js